import axios from "axios";
import { getAPIUrl } from '../helpers/common'

const Axios = axios.create({
    baseURL: getAPIUrl()
})  

export default Axios;
